/* eslint-disable no-shadow */
export enum AuthorizedState {
  Authorized = 'Authorized',
  Unauthorized = 'Unauthorized',
  Unknown = 'Unknown',
}
